module.exports = __webpack_public_path__ + "img/birthday.bd0e61fd.svg";